import { render, staticRenderFns } from "./PublisherShow.vue?vue&type=template&id=02fe59c2&scoped=true&"
import script from "./PublisherShow.vue?vue&type=script&lang=js&"
export * from "./PublisherShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fe59c2",
  null
  
)

export default component.exports